import type { ComponentProps, ReactNode } from 'react';
import { ThreadSummaryProvider } from '@/components/desktop-shell/thread-summary';
import { NotificationsProvider } from '@/features/notifications/notifications';
import { PictureInPictureHost } from '@/features/picture-in-picture/picture-in-picture-host';
import { AssistantShow } from '@/features/voice-call/assistant-show';
import { IncomingCallHost } from '@/features/voice-call/incoming-call';
import { LiveCallProvider } from '@/features/voice-call/live-call';
import { PREVIEW_EVENT_TYPES, PREVIEW_NOTIFICATIONS } from '@/lib/desktop-preview-data';

/**
 * What lives above the conversations of the shell: their summaries, the notifications, the live
 * call (with what the assistant shows) and picture in picture. A preview has none, but the boards'
 * notifications.
 */
export function ShellServices({
  preview,
  chatId,
  workspace,
  renderSummary,
  children,
}: {
  preview: boolean;
  chatId: string;
  workspace: string | null;
  renderSummary: ComponentProps<typeof ThreadSummaryProvider>['value'];
  children: ReactNode;
}) {
  return (
    <ThreadSummaryProvider value={renderSummary}>
      <NotificationsProvider
        enabled={!preview}
        preview={preview ? PREVIEW_NOTIFICATIONS : undefined}
        previewTypes={preview ? PREVIEW_EVENT_TYPES : undefined}
      >
        <LiveCallProvider enabled={!preview} openConversation={chatId} openWorkspace={workspace}>
          <PictureInPictureHost enabled={!preview} />
          {!preview && <AssistantShow />}
          {!preview && <IncomingCallHost />}
          {children}
        </LiveCallProvider>
      </NotificationsProvider>
    </ThreadSummaryProvider>
  );
}
